import Types from "./types";
import { BffDataAU, ListingServiceAUV2 } from "../../../service";
import { ZERO_DP_VARIANTS } from "../../../constants/optimize-constants";
import { NUMBER } from "../../../constants/app-constants";

const setDealerInfo = (data) => ({
    type: Types.SET_DEALER_INFO,
    data
});

const getDealerInfoStarted = () => ({
    type: Types.GET_DEALER_INFO_STARTED
});

const getDealerInfoSuccess = (data) => ({
    type: Types.GET_DEALER_INFO_SUCCESS,
    data
});

const getDealerInfoFailed = (error) => ({
    type: Types.GET_DEALER_INFO_FAILED,
    error
});

const updateDealerSSRStatus = (isSSR) => ({
    type: Types.UPDATE_DEALER_SSR_STATUS,
    isSSR
});

const getDealerConfigStarted = () => ({
    type: Types.GET_DEALER_CONFIG_STARTED
});

const getDealerConfigSuccess = (data) => ({
    type: Types.GET_DEALER_CONFIG_SUCCESS,
    data
});

const getDealerConfigFailed = (error) => ({
    type: Types.GET_DEALER_CONFIG_FAILED,
    error
});

const getDealerConfig = ({dealerId}) => async (dispatch) => {
    dispatch(getDealerConfigStarted());
    try {
        const response = await BffDataAU.getDealerConfig({dealerId});
        dispatch(getDealerConfigSuccess(response.data));
        return response.data;
    } catch (error) {
        dispatch(getDealerConfigFailed(error));
        throw error;
    }
};

const getDealerInfo = ({dealerId}) => async (dispatch, getState) => {
    dispatch(getDealerInfoStarted());
    const {
        user: {
            secureToken
        }
    } = getState();
    try {
        const response = await BffDataAU.getDealerInfo({dealerId, token: secureToken});
        dispatch(getDealerInfoSuccess(response.data));

        // Automatically fetch dealer config after successfully fetching dealer info
        try {
            await dispatch(getDealerConfig({dealerId}));
        } catch (configError) {
            // Don't fail the entire operation if config fails
            // console.error("Failed to fetch dealer config:", configError);
        }

        return response.data;
    } catch (error) {
        dispatch(getDealerInfoFailed(error));
        throw error;
    }
};

const fetchDealerCmsConfigInit = () => ({
    type: Types.FETCH_DEALER_CMS_CONFIG
});

const fetchDealerCmsConfigSuccess = (data) => ({
    type: Types.FETCH_DEALER_CMS_CONFIG_SUCCESS,
    data
});

const fetchDealerCmsConfigFailure = (error) => ({
    type: Types.FETCH_DEALER_CMS_CONFIG_FAILURE,
    error
});

const fetchDealerCmsConfig = (params) => (dispatch) => {
    dispatch(fetchDealerCmsConfigInit());
    return new Promise((resolve, reject) => {
        BffDataAU.getCmsContent(params)
            .then((response) => {
                dispatch(fetchDealerCmsConfigSuccess(response.data));
                resolve(response.data);
            })
            .catch((error) => {
                dispatch(fetchDealerCmsConfigFailure(error));
                reject(error);
            });
    });
};

const fetchDealerInventoryStarted = () => ({
    type: Types.FETCH_DEALER_INVENTORY_STARTED
});

const fetchDealerInventorySuccess = (data, params) => ({
    type: Types.FETCH_DEALER_INVENTORY_SUCCESS,
    data,
    params
});

const fetchDealerInventoryFailed = (error) => ({
    type: Types.FETCH_DEALER_INVENTORY_FAILED,
    error
});

const resetDealerInventory = () => ({
    type: Types.RESET_DEALER_INVENTORY
});

const fetchDealerInventory = ({dealerId, page = 0, size = NUMBER.TWENTY, sort = "", sortingVariant = ""}) => async (dispatch, getState) => {
    dispatch(fetchDealerInventoryStarted());
    const {
        user: { secureToken, isUserZeroDpVariant, isGuestLogin, userGeoData }
    } = getState();

    const params = {
        page,
        size,
        searchSimilarVariant: false,
        entireMakeSelected: false,
        zeroDpVariant: isUserZeroDpVariant ? ZERO_DP_VARIANTS.ZERO_DP : ZERO_DP_VARIANTS.NON_ZERO_DP
    };

    let queryString = `spath=buy-used-cars-australia&sf=dealerCode:${dealerId}`;
    if (sort) {
        queryString += `&sort=${sort}`;
    }

    try {
        const response = await ListingServiceAUV2.fetchDealerInventoryV2(
            params,
            queryString,
            isGuestLogin ? null : secureToken,
            userGeoData,
            sortingVariant
        );
        dispatch(fetchDealerInventorySuccess(response.data, params));
        return response.data;
    } catch (error) {
        dispatch(fetchDealerInventoryFailed(error));
        throw error;
    }
};

export {
    setDealerInfo,
    getDealerInfoStarted,
    getDealerInfoSuccess,
    getDealerInfoFailed,
    getDealerInfo,
    updateDealerSSRStatus,
    fetchDealerCmsConfig,
    getDealerConfigStarted,
    getDealerConfigSuccess,
    getDealerConfigFailed,
    getDealerConfig,
    fetchDealerInventoryStarted,
    fetchDealerInventorySuccess,
    fetchDealerInventoryFailed,
    fetchDealerInventory,
    resetDealerInventory
};
